<template>
<m-pageframe
    title="Search Typeform(s)"
>
<v-container>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autocomplete="off"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickUpdateTypeforms()"
                >
                    <v-list-item-title>Update list of Typeforms...</v-list-item-title>
                </v-list-item>

            </v-list>
        </v-menu> 
    </v-text-field>

    <v-checkbox
        v-model="only_show_bound"
        label="Only show typeforms connected to an Organization"
        v-on:change="doUpdate"
    >
    </v-checkbox>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y
            >
                
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                     <v-list-item
                        v-on:click="onClickSettings(item)"
                    >
                        <v-list-item-title>Settings...</v-list-item-title>
                    </v-list-item>

                     <v-divider/>

                    <v-list-item
                        v-on:click="onClickViewForm(item)"
                    >
                        <v-list-item-title>View...</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                        v-on:click="onClickEditForm(item)"
                    >
                        <v-list-item-title>Edit...</v-list-item-title>
                    </v-list-item>
                    
                </v-list>
            </v-menu>

        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],
            only_show_bound: true,

            headers: [
                { text: 'Form Id', value: 'form_id'},
                { text: 'Title', value: 'title'},
                { text: 'Organization', value: 'organization_label' },
                { text: 'Inbox', value: 'inbox_internal_label' },
                { text: 'Action', value: 'action' }
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            let params =  {
                    'full_text': this.full_text,
                };

            if ( this.only_show_bound )
            {
                params['organization_id'] = { type: 'is-not-blank' };
            }

            this.$rc.rest(
                'LIST: /api/v1/integrations/typeform/forms',
            
                params,
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to list tyepform(s)');
                },
            );
        },

        onClickUpdateTypeforms()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET: /api/v1/integrations/typeform/refresh-meta-data',
            
                {
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$rc.snackbar('Updating list of typeforms.  This may take a minute or so');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to refresh meta data');
                },
            );
        },

        onClickViewForm(item)
        {
            window.open(item.display_url);
        },

        onClickEditForm(item)
        {
            window.open(item.edit_url);
        },

        onClickSettings(item)
        {
            this.$router.push({
                'name': 'admin-settings-typeform',
                'params' : {
                    'form_id': item.form_id
                }
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>